import React from 'react'
import { EmeraldHost } from '../config';
import '../assets/css/components/authentication-notice.css'

const AuthenticationNotice = props =>
  <div className='authentication-notice'>
    <div className='text-container'>
      <p className='title'>Sorry, your session has expired.</p>
      <p className='prompt'>You need to log in again. Don't worry, we'll bring you back here when you're done!</p>
      <a href={encodeURI(EmeraldHost()+'login?service='+document.location.href)} className='btn btn-primary'>LOG IN</a>
    </div>
  </div>

export default AuthenticationNotice
